module.exports = __webpack_public_path__ + "img/product-tutorial-3-big-flower.f9ba2d70.svg";